export default __webpack_public_path__ + "static/media/coresanscr15-webfont.4d8cb757.woff";